import anime from 'animejs/lib/anime.es';
import ScrollMagic from 'scrollmagic';
import { breakpoints } from './variables';

const _scrollAnimateShapes = ({
  containerEl,
  shapeContainer,
  offset = 0,
  count
}) => {
  // Create animation timeline
  const timeline = anime.timeline({
    easing: 'easeOutExpo',
    duration: 1000,
    autoplay: false
  });

  [...shapeContainer.childNodes].forEach((shape, index) => {
    timeline.add(
      {
        targets: shape,
        translateY: [80, 0],
        opacity: [0, 1]
      },
      (1000 / count) * index
    );
  });

  // Add scrollmagic scene
  const controller = new ScrollMagic.Controller();
  new ScrollMagic.Scene({
    triggerElement: containerEl,
    duration: window.innerHeight * 0.7,
    offset,
    triggerHook: 1 // 0 = onLeave, 1 = onEnter
  })
    .on('progress', event => {
      timeline.seek(timeline.duration * event.progress);
    })
    .addTo(controller);
};

const _animateShapes = ({ shapeContainer, count }) => {
  // Create animation timeline
  const timeline = anime.timeline({
    easing: 'easeOutExpo',
    duration: 600
  });

  [...shapeContainer.childNodes].forEach((shape, index) => {
    timeline.add(
      {
        targets: shape,
        translateY: [80, 0],
        opacity: [0, 1]
      },
      (600 / count) * index
    );
  });
};

const createScrollShapes = ({
  containerEl,
  count,
  prefix = '',
  scrollAnimate = true,
  offset = 0
}) => {
  const breakpoint = window.matchMedia(`(min-width: ${breakpoints.desktop}px)`);
  const shapeContainer = document.createElement('div');
  shapeContainer.classList.add(`${prefix}shapes-container`);

  for (let i = 0; i < count; i++) {
    const shape = document.createElement('span');
    shape.classList.add(`shape-${i + 1}`);
    shapeContainer.append(shape);
  }

  containerEl.append(shapeContainer);

  if (!breakpoint.matches) return;

  if (scrollAnimate) {
    _scrollAnimateShapes({ containerEl, shapeContainer, offset, count });
  } else {
    _animateShapes({ shapeContainer, count });
  }
};

export default createScrollShapes;
